import React from "react";
import { Box, Typography } from "@mui/material";
import GradientIcon from "../../components/GradientIcon";

const gradientHoverSx = {
  position: "relative",
  borderRadius: "16px",
  overflow: "hidden", // Important

  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: "inherit",
    padding: "2px",
    background: "linear-gradient(90deg, #FF7FAC, #5834BA)",
    WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    maskComposite: "exclude",
    opacity: 0,
    transition: "opacity 0.3s ease",
  },

  // Very very important to works correctly
  ".step-root:hover &::before": {
    opacity: 1,
  },
};

export default function StepCard({ title, description, icon }) {
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#F9F9F9",
        borderRadius: "16px",
        boxShadow: "0px 1px 1px 0px #00000024",
        px: "16px",
        py: "24px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: "16px",
        ...gradientHoverSx,
      }}
    >
      <GradientIcon
        icon={icon}
        size={40}
        bordered
        boxSize={80}
        borderRadius={24}
        borderWidth={2}
        angle="90"
        sx={{ margin: "0 auto 16px" }}
      />
      <Box>
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: 600,
            letterSpacing: "0.15px",
            lineHeight: 1.6,
            mb: 1,
            color: "#000000DE",
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: "0.875rem",
            fontWeight: 400,
            color: "#00000099",
            lineHeight: 1.4,
            letterSpacing: "0.17px",
          }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
}
